import {
  InfiniteComboBox,
  type InfiniteComboBoxProps,
} from '@/components/InfiniteComboBox';
import { useField } from 'formik';
import { getFormFieldClasses } from '@/utility/utility';
import { FieldWrapper, type FieldWrapperConfig } from './FieldWrapper';

interface InfiniteComboBoxFieldProps<TParams, TData>
  extends Omit<InfiniteComboBoxProps<TParams, TData>, 'value' | 'onChange'>,
    FieldWrapperConfig {}

export const InfiniteComboBoxField = <
  TParams extends object | undefined,
  TData,
>({
  name,
  label,
  width,
  infoText,
  className = '',
  showErrorSpace,
  disabled = false,
  fieldClassName = '',
  labelHint,
  labelButton,
  ...props
}: InfiniteComboBoxFieldProps<TParams, TData> & { onAddNew?: () => void }) => {
  const [field, meta, helpers] = useField(name);

  const wrapperProps = {
    name,
    disabled,
    label,
    errorMeta: meta,
    fieldClassName,
    infoText,
    labelHint,
    showErrorSpace,
    labelButton,
  };

  return (
    <FieldWrapper {...wrapperProps}>
      <InfiniteComboBox
        {...props}
        width={width}
        value={field.value}
        disabled={disabled}
        className={getFormFieldClasses({ meta, disabled, className })}
        error={meta.touched && meta.error ? meta.error : undefined}
        onChange={(val: string | string[] | undefined) => {
          helpers.setValue(val);
          helpers.setTouched(true, false);
        }}
      />
    </FieldWrapper>
  );
};
